module.exports = __webpack_public_path__ + "static/img/refuse_vid.54f650d4.png";